import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";
import swal from "sweetalert2";

const Notification = {};
const service = function (message, setting = {}) {
  const defaultSetting = {
    title: "הודעת מערכת",
    color: "",
    message: message,
    rtl: true,
    position: "topCenter",
  };
  iziToast.show(Object.assign(defaultSetting, setting));
};
const success = function (message = "הפעולה הצליחה", setting = {}) {
  const defaultSetting = {
    title: "",
    message: message,
    rtl: true,
    position: "topCenter",
  };
  iziToast.success(Object.assign(defaultSetting, setting));
};
const error = function (message = "שגיאה, אנא בדוק את כל השדות", setting = {}) {
  const defaultSetting = {
    title: "הודעת מערכת",
    message: message,
    rtl: true,
    timeout: false,
    position: "topCenter",

  };
  iziToast.error(Object.assign(defaultSetting, setting));
};
Notification.install = function (Vue, options) {
  Vue.prototype.$notfication = {
    alert (err) {
      alert(err);
    },
    warning (title = "האם אתה בטוח?", text = "", options = {}) {
      const def = {
        title: title,
        text: text,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      };
      return swal.fire(Object.assign(def, options));
    },
    service,
    success,
    error,
  };
};
export default Notification;
